import React from "react"
import animations from "./animations"
import { motion } from "framer-motion"

export default function Base() {
  const { loop, discLoop } = animations

  return (
    <g>
      <motion.path
        {...loop.lightRays}
        fill="url(#ceiling-light-rays)"
        d="M348.4,196.4V3.1H101.6v193.3H348.4z"
      />
      <motion.path
        {...loop.ceilingGlow}
        fill="url(#ceiling-glow)"
        d="M348.4,149.6V5.7H101.6v143.9H348.4z"
      />

      <motion.ellipse
        fill="url(#floor-glow)"
        {...loop.hologramFloorGlow}
        cx={225}
        cy={436.5}
        rx={241.1}
        ry={113.6}
      />

      <motion.path
        {...loop.hologramShadowFade}
        fill="#0C131F"
        d="M396.3,415c0-10.9-2.2-15.6-2.2-15.6l-9.9,0.7c-4.2-13-13.3-25.1-26.2-35.6c-24.1-19.5-61.8-33.5-104.7-37.9 H225h-28.3c-42.9,4.5-80.6,18.5-104.7,37.9c-12.9,10.5-22,22.6-26.2,35.6l-9.9-0.7c0,0-2.2,4.7-2.2,15.6s2.2,17.2,2.2,17.2l9.9-0.7 c4.2,13,13.3,25.1,26.2,35.6c24.1,19.5,56.4,33.5,99.2,37.9l-0.9,7.7c0,0,14.8,4,34.7,4s34.2-4,34.2-4l-0.9-7.7 c42.9-4.5,75.7-18.5,99.8-37.9c12.9-10.5,22-22.6,26.2-35.6l9.9,0.7C394.2,432.2,396.3,425.9,396.3,415z"
      />

      <BodySection />
      <InfoScreen />

      <motion.path
        fill="url(#bevel-glow)"
        {...loop.bevelGlow}
        d="M225,296.9c-71.1,0-128.7,30.6-128.7,67c0,37,57.6,67,128.7,67c-68.1,0-123.4-28.8-123.4-64.2
  c0-35.5,55.4-64.2,123.4-64.2s123.4,28.8,123.4,64.2s-55.2,64.2-123.4,64.2c71.1,0,128.7-30,128.7-67
  C353.7,327.4,296.1,296.9,225,296.9z"
      />

      {Array.from(Array(2)).map((_, index) => (
        <motion.ellipse
          fill="url(#inner-glow)"
          {...loop.innerGlow}
          key={index}
          cx={225}
          cy="366.6"
          rx="123.4"
          ry="64.2"
        />
      ))}

      <motion.path
        fill="url(#light-rays)"
        {...loop.lightRays}
        d="M101.6,0v366.6c0,35.5,55.3,64.2,123.4,64.2s123.4-28.8,123.4-64.2V0H101.6z"
      />

      <motion.g {...loop.discFade}>
        <motion.path
          initial={{ fill: "#B0E1EC" }}
          {...discLoop.clockwise}
          d="M195.8,284.1c44.3-16.1,93.3,6.7,109.4,51l0,0c16.1,44.3-6.7,93.3-51,109.4l0,0c-44.3,16.1-93.3-6.7-109.4-51
              l0,0C128.6,349.2,151.4,300.2,195.8,284.1L195.8,284.1z M259.3,290.7c-18.8-8.8-41-10.4-62.1-2.7l0,0c-21,7.7-37.1,23.2-45.9,42
              l0,0c-8.8,18.8-10.4,41-2.7,62.2l0,0c7.7,21,23.2,37.1,42,45.9l0,0c18.8,8.8,41,10.4,62.1,2.7l0,0c21-7.7,37.1-23.2,45.9-42l0,0
              c8.8-18.8,10.4-41,2.7-62.2l0,0C293.6,315.5,278.1,299.5,259.3,290.7L259.3,290.7z"
        />

        <motion.path
          initial={{ fill: "#B0E1EC" }}
          {...discLoop.clockwise}
          d="M225.2,485.7c-12.3,0-24.5-1.9-36.4-5.6l0.9-1.7c11.4,3.5,23.3,5.3,35.3,5.3c11.1,0,22.1-1.6,32.9-4.6l0.7,1.8
          C247.7,484.1,236.5,485.7,225.2,485.7z M272.1,474c12-5.1,23-12.1,32.7-20.9l1.3,1.3c-9.7,8.9-21,16.1-33.4,21.4L272.1,474z
           M152,461.2c-14.8-11.1-26.9-25.5-35.2-42l1.8-0.6c8.2,16.1,20,30.1,34.3,40.8L152,461.2z M315.3,442.2
          c7.1-8.3,13.1-17.5,17.8-27.5c11.2-24.1,14.1-51.4,8.1-77.2l1.8-0.7c8.9,37.7-0.9,77.2-26.3,106.7L315.3,442.2z M106.4,390
          c-8.1-37.1,1.8-76,26.7-104.9l1.3,1.3c-7.2,8.5-13.2,17.8-17.7,27.5c-10.9,23.4-13.9,50.1-8.5,75.3L106.4,390z M330.4,308.5
          c-8.4-15.9-20.4-29.8-35-40.5l0.9-1.7c14.9,10.8,27.3,25.1,35.9,41.5L330.4,308.5z M143.7,274.3c9.7-8.8,20.7-15.8,32.6-21.1
          l0.7,1.8c-11.7,5.2-22.4,12.1-31.9,20.5L143.7,274.3z M190.6,248.2c11.2-3.3,22.8-5,34.4-5c11.6,0,23.1,1.7,34.2,5l-0.9,1.7
          c-10.8-3.2-21.9-4.8-33.1-4.8c-11.5,0-22.9,1.7-34,5L190.6,248.2z"
        />

        <motion.circle
          initial={{
            fill: "none",
            stroke: "#B0E1EC",
            strokeWidth: "14.8029",
            strokeMiterlimit: "10",
            strokeDasharray: "1.8476,5.5427",
          }}
          {...discLoop.counterClockwise}
          cx={225}
          cy={364.6}
          r={102.3}
        />
      </motion.g>
    </g>
  )
}

const InfoScreen = () => {
  return (
    <>
      {[
        {
          dotState: 1,
          shape: "M308.7,4.3L310.6 4.2 310.6 20 308.7 20.2 z",
        },
        {
          dotState: 2,
          shape: "M314.7,3.9L316.6 3.8 316.6 19.6 314.7 19.7 z",
        },
        {
          dotState: 2,
          shape:
            "M320.7,3.2c0.6,0,1.3-0.1,1.9-0.1v15.8c-0.6,0-1.2,0.1-1.9,0.1V3.2z",
        },
        {
          dotState: 1,
          shape:
            "M326.7,2.5c0.6-0.1,1.3-0.1,1.9-0.2v15.8c-0.6,0.1-1.2,0.1-1.9,0.2V2.5z",
        },
        {
          dotState: 2,
          shape:
            "M332.7,1.2c0.6-0.1,1.3-0.1,1.9-0.2v15.8c-0.6,0.1-1.2,0.1-1.9,0.2V1.2z",
        },
      ].map((node, index) => {
        return (
          <motion.path
            key={index}
            fill="#B0E1EC"
            d={node.shape}
            initial={{ opacity: 0 }}
            animate={{
              opacity:
                node.dotState === 1
                  ? [0, 1, 1, 0]
                  : node.dotState === 2
                  ? [1, 0, 0, 1]
                  : null,
            }}
            transition={{
              times: [0, 0.1, 0.9, 1],
              duration: 1,
              repeatDelay: 1,
              ease: "easeInOut",
              repeat: Infinity,
            }}
          />
        )
      })}

      <path
        fill="#0D1622"
        d="M92.7,445.2c13.1,13.5,33.9,24.9,58.9,32.4v-28c-24.6-7.2-44.8-17.7-58.9-30.6C92.7,419,92.7,445.2,92.7,445.2z"
      />

      {[
        {
          pos: [0, 0, 3.25, 3.25, 6.5, 6.5, 9.75, 9.75, 13],
          shape:
            "M96.5,428.6v1.9c4.1,3.4,8.7,6.6,13.7,9.6v-1.8C105.2,435.3,100.6,432.1,96.5,428.6z",
        },
        {
          pos: [0, 0, 3.25, 3.25, 6.5, 6.5, 9.75, 9.75, -3.25],
          shape:
            "M103.9,437.5c-2.6-1.8-5.1-3.7-7.4-5.6v1.9c2.3,1.9,4.8,3.7,7.4,5.5V437.5z",
        },
        {
          pos: [0, 0, 3.25, 3.25, 6.5, 6.5, -6.5, -6.5, -3.25],
          shape:
            "M106.1,442.2c-3.4-2.3-6.6-4.7-9.6-7.1v1.9c3,2.4,6.2,4.8,9.6,7V442.2z",
        },
        {
          pos: [0, 0, 3.25, 3.25, -9.75, -9.75, -6.5, -6.5, -3.25],
          shape:
            "M98.2,439.7c-0.6-0.5-1.1-0.9-1.7-1.4v1.9c0.6,0.5,1.1,0.9,1.7,1.4V439.7z",
        },
        {
          pos: [0, 0, -13, -13, -9.75, -9.75, -6.5, -6.5, -3.25],
          shape:
            "M101.8,445.7c-1.8-1.3-3.6-2.7-5.2-4.1v1.9c1.7,1.4,3.4,2.7,5.2,4V445.7z",
        },
      ].map((node, index) => (
        <motion.path
          key={index}
          fill="#B0E1EC"
          animate={{
            y: node.pos,
          }}
          transition={{
            times: [0, 0.25, 0.251, 0.5, 0.51, 0.75, 0.751, 0.99, 1],
            duration: 2,
            ease: "easeInOut",
            repeat: Infinity,
            repeatDelay: 0.5,
          }}
          d={node.shape}
        />
      ))}

      {[
        {
          dotState: 1,
          shape:
            "M140.6,452.6v1.6c0.7,0.2,1.3,0.5,2,0.7v-1.6C141.9,453.1,141.2,452.9,140.6,452.6z",
        },
        {
          dotState: 2,
          shape:
            "M144.5,454v1.6c0.7,0.2,1.4,0.4,2,0.7v-1.6C145.9,454.4,145.2,454.2,144.5,454z",
        },
        {
          dotState: 2,
          shape:
            "M140.6,456.2v1.6c0.7,0.2,1.3,0.5,2,0.7v-1.6C141.9,456.7,141.2,456.5,140.6,456.2z",
        },
        {
          dotState: 1,
          shape:
            "M144.5,457.6v1.6c0.7,0.2,1.4,0.4,2,0.7v-1.6C145.9,458,145.2,457.8,144.5,457.6z",
        },
        {
          dotState: false,
          shape:
            "M140.6,459.8v1.6c0.7,0.2,1.3,0.5,2,0.7v-1.6C141.9,460.3,141.2,460.1,140.6,459.8z",
        },
        {
          dotState: false,
          shape:
            "M144.5,461.2v1.6c0.7,0.2,1.4,0.4,2,0.7v-1.6C145.9,461.6,145.2,461.4,144.5,461.2z",
        },
        {
          dotState: 1,
          shape:
            "M140.6,463.4v1.6c0.7,0.2,1.3,0.5,2,0.7v-1.6C141.9,463.9,141.2,463.7,140.6,463.4z",
        },
        {
          dotState: false,
          shape:
            "M144.5,464.8v1.6c0.7,0.2,1.4,0.4,2,0.7v-1.6C145.9,465.3,145.2,465,144.5,464.8z",
        },
        {
          dotState: 1,
          shape:
            "M140.6,467v1.6c0.7,0.2,1.3,0.5,2,0.7v-1.6C141.9,467.5,141.2,467.3,140.6,467z",
        },
        {
          dotState: 2,
          shape:
            "M144.5,468.4v1.6c0.7,0.2,1.4,0.4,2,0.7v-1.6C145.9,468.9,145.2,468.6,144.5,468.4z",
        },
      ].map((node, index) => {
        return (
          <motion.path
            key={index}
            fill="#B0E1EC"
            d={node.shape}
            initial={{ oapcity: 0 }}
            animate={{
              opacity:
                node.dotState === 1
                  ? [0, 1, 1, 0]
                  : node.dotState === 2
                  ? [1, 0, 0, 1]
                  : null,
            }}
            transition={{
              times: [0, 0.1, 0.9, 1],
              duration: 1,
              repeatDelay: 1,
              ease: "easeInOut",
              repeat: Infinity,
            }}
          />
        )
      })}
    </>
  )
}

const BodySection = () => (
  <>
    {/* UPPER */}
    <polygon
      fill="url(#ceiling-side-plate)"
      points="77,13.2 94.9,34.8 88.6,34.8 68,14.6 	"
    />
    <polygon
      fill="url(#ceiling-side-plate)"
      points="373,13.2 355.1,34.8 361.4,34.8 382,14.6 	"
    />
    <path
      fill="url(#ceiling-bevel)"
      d="M68,0v14.6l10.1-0.1l16.8,20.3h-2.7l4.5,5.4c0,0,52,15.2,128.4,15.2l0,0v0c76.4,0,128.4-15.2,128.4-15.2
      l4.5-5.4h-2.7l16.8-20.3l10.1,0.1V0H68z"
    />

    <path
      fill="url(#ceiling-front-plate-bevel)"
      d="M249.3,50.3v-6.1c-7.9-0.6-16-1-24.3-1s-16.3,0.3-24.3,1v6.1c7.9-0.7,16-1.1,24.3-1.1S241.4,49.5,249.3,50.3z"
    />

    <path
      fill="url(#ceiling-front-plate)"
      d="M225.2,25.9c-9.3,0-18.5,0.1-27.6,0.5l3.1,17.7c7.9-0.6,16-1,24.3-1s16.3,0.3,24.3,1l3.1-17.7
          C243.5,26.1,234.5,25.9,225.2,25.9z"
    />

    <polyline
      fill="#111C2C"
      points="197.4,26.4 197.4,31 200.6,50.3 200.6,44.2 	"
    />

    <polygon
      fill="#111C2C"
      points="252.5,26.4 252.5,31 249.3,50.3 249.3,44.2 	"
    />

    {/* LOWER */}
    <path
      fill="#17253B"
      d="M225,296.9c-50.7,0-96.8,13.9-124,34.8c-15.4,11.8-26.7,27.9-26.7,45.3c0,16.9,9.8,32.5,26.6,45.4
  C128.2,443.3,174.4,457,225,457c53.5,0,96.8-13.7,124.1-34.6c16.8-12.9,26.6-28.6,26.6-45.4c0-17.4-11.3-33.4-26.7-45.3
  C314.5,305.1,275.7,296.9,225,296.9z"
    />

    <path
      fill="#17253B"
      d="M200.9,297.9v-7.6L199,298l0,0C199.7,298,200.3,298,200.9,297.9z"
    />
    <path
      fill="#17253B"
      d="M249,297.9v-7.6l1.9,7.7l0,0C250.3,298,249.6,298,249,297.9z"
    />
    <path
      fill="url(#rear-plate-top)"
      d="M225,296.9c8.2,0,16.2,0.4,24,1v-7.6c-7.9-0.7-15.8-1-24-1s-16.2,0.4-24,1v7.6
  C208.8,297.2,216.8,296.9,225,296.9z"
    />

    <path
      fill="#111C2C"
      d="M375.7,376.9c0,44.2-67.5,80-150.7,80s-150.8-35.8-150.8-80v33.2c0,44.2,67.5,80,150.7,80s150.7-35.8,150.7-80
  v-33.2H375.7z"
    />

    <path
      fill="url(#front-plate-top)"
      d="M225,437.8c-8.2,0-16.2-0.4-24-1.1v6c7.9,0.7,15.8,1,24,1s16.2-0.4,24-1v-6C241.2,437.5,233.2,437.8,225,437.8z"
    />
    <path
      fill="url(#front-plate-bevel)"
      d="M252.2,460.2l-3.1-17.5c-7.9,0.7-15.8,1-24,1s-16.2-0.4-24-1l-3.1,17.5c9,0.4,18,0.5,27.2,0.5
  S243.2,460.5,252.2,460.2z"
    />
    <polygon
      fill="#111C2C"
      points="200.9,442.7 200.9,436.7 197.8,455.7 197.8,460.2 "
    />
    <polygon
      fill="#111C2C"
      points="249,442.7 249,436.7 252.1,455.7 252.1,460.2 "
    />
    <path
      fill="#111C2C"
      d="M225,460.7c-9.1,0-18.2-0.2-27.2-0.5v35.4c9,0.4,18,0.5,27.2,0.5s18.2-0.2,27.2-0.5v-35.4
  C243.3,460.5,234.1,460.7,225,460.7z"
    />

    <polygon
      fill="#111C2C"
      points="357.5,377.2 373.3,391.4 373.3,424.3 380,424.3 380,388.3 365.3,377.2 "
    />
    <path
      fill="#111C2C"
      d="M380,388.3v36v-0.1l0,0c1.3-4.2,2-8.6,2-13v-41.1C382,377.5,380,388.3,380,388.3z"
    />
    <path
      fill="url(#right-plate-top)"
      d="M365.3,351.5h-7.7c1.5,4.2,2.2,8.5,2.2,12.9s-0.8,8.7-2.2,12.9h7.7c1.5-4.2,2.2-8.5,2.2-12.9
  S366.7,355.7,365.3,351.5z"
    />
    <path
      fill="url(#right-plate-bevel)"
      d="M380.3,359.6l-15.1-8.1c0,0,0.1,0.3,0.3,0.8c1.3,3.9,2,8,2,12.1c0,4.4-0.8,8.7-2.2,12.9l14.8,11.1
  c0,0,2-10.8,2-18.2C382,362.7,380.3,359.6,380.3,359.6z"
    />

    <polygon
      fill="#111C2C"
      points="92.5,377.2 76.7,391.4 76.7,424.3 70,424.3 70,388.3 84.7,377.2 "
    />
    <path
      fill="#111C2C"
      d="M70,388.3v36v-0.1l0,0c-1.3-4.2-2-8.6-2-13v-41.1C68,377.5,70,388.3,70,388.3z"
    />
    <path
      fill="url(#left-plate-top)"
      d="M84.7,351.5h7.7c-1.5,4.2-2.2,8.5-2.2,12.9s0.8,8.7,2.2,12.9h-7.7c-1.5-4.2-2.2-8.5-2.2-12.9
  S83.3,355.7,84.7,351.5z"
    />
    <path
      fill="url(#left-plate-bevel)"
      d="M69.7,359.6l15.1-8.1c0,0-0.1,0.3-0.3,0.8c-1.3,3.9-2,8-2,12.1c0,4.4,0.8,8.7,2.2,12.9l-14.7,11
  c0,0-2-10.8-2-18.2S69.7,359.6,69.7,359.6z"
    />
  </>
)
